module.exports = __webpack_public_path__ + "img/select-business.2e90e36a.svg";